const truncateStr = value => {
  if (!value) return '';
  const string = value?.toString?.() ?? '';
  return string.length > 50 ? string.substr(0, 50).trim() + '...' : string;
};

export default truncateStr;
